import React, { useEffect, useRef, useState } from 'react'
import { eFormButtonsContainer, eformInput, serviceRequestHeadContainer, serviceRequestTitle } from '../../common/cssclasses';
import EahsForm from '../../components/EahsForm';
import { getOwnerServicesTypes, sendOwnerServicesData } from './api/ownerServicesApi';
import SubmitServiceBtn from '../../components/servicesButtons/SubmitServiceBtn';
import SimpleUpload from '../../components/SimpleFileUpload';
import Loader from '../../components/Loader';
import { useTranslate } from '../../components/TranslationText';
import NetaqInput from '../../components/NetaqInput';
import { validateInputs } from '../../helper/validaiteInputs';
import { toast, ToastContainer } from 'react-toastify';
import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate } from 'react-router';
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;


export default function OwnerServicesForm() {
    const initInputes = {
        OwnerServiceId: '',
        OwnerNameEn: '',
        OwnerNameAr: '',
        ChargePersonNameEn: '',
        ChargePersonNameAr: '',
        CommercialNameEn: '',
        CommercialNameAr: '',
        Phone: '',
        Mobile: '',
        Website: '',
        Email: '',
        About: '',
        AboutAr: '',
    };

    const { translate } = useTranslate();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [types, setTypes] = useState([]);
    const [inputes, setInputes] = useState(initInputes);
    const [idFile, setIdFile] = useState([]);
    const [commercialLicenseFile, setCommercialLicenseFile] = useState([]);
    const [companyProfileFile, setCompanyProfileFile] = useState([]);
    const [companyLogoFile, setCompanyLogoFile] = useState([]);
    const [websiteBannerFile, setWebsiteBannerFile] = useState([]);
    const [galleryImages, setGalleryImages] = useState([]);
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
    const [isMobileNumberValid, setIsMobileNumberValid] = useState(true);
    const recaptchaRef = useRef();
    const [recaptchaToken, setRecaptchaToken] = useState("");
    const [recaptchaValidate, setRecaptchaVaidate] = useState(false);
    const [agreeTerms, setAgreeTermsAndConditions] = useState(false);

    const handleUpload = (e, setData) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];

                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }

                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }
            setData(fileListHook);
        }
    };

    const handleChange = (event) => {
        if (event.target.required == false) {
            setInputes((prev) => {
                const updated = { ...prev };
                if (event.target.value.trim() === '') {
                    delete updated[event.target.name];
                } else {
                    updated[event.target.name] = event.target.value;
                }

                return updated;
            });
        } else {
            setInputes((prev) => ({
                ...prev,
                [event.target.name]: event.target.value,
            }));
        }
    }

    const setPhoneNumber = (value, name) => {
        setInputes((prev) => ({
            ...prev,
            [name]: value
        }));
    }

    useEffect(() => {
        getOwnerServicesTypes().then(res => {
            setTypes(res);
        })
    }, [])

    async function submitForm() {
        if (isPhoneNumberValid == false || isMobileNumberValid == false) {
            return;
        }
        try {
            const valid = validateInputs(inputes, toast, translate)
            if (valid) {
                const sendFormData = new FormData();
                for (const [key, value] of Object.entries(inputes)) {
                    sendFormData.append(key, value);

                }
                if (idFile?.length <= 0) {
                    const message = translate('web.IdFile', 'Id File') + " " + translate('web.isRequired')
                    toast.error(message);
                    return;
                }
                if (commercialLicenseFile?.length <= 0) {
                    const message = translate('web.commercialLicenseFile', 'Commercial License File') + " " + translate('web.isRequired')
                    toast.error(message);
                    return;
                }
                if (companyLogoFile?.length <= 0) {
                    const message = translate('web.companyLogoFile', 'Company Logo File') + " " + translate('web.isRequired')
                    toast.error(message);
                    return;
                }
                if (websiteBannerFile?.length <= 0) {
                    const message = translate('web.WebsiteBannerFile', 'Website Banner File') + " " + translate('web.isRequired')
                    toast.error(message);
                    return;
                }
                setLoading(true)

                sendFormData.append('IdFile', idFile[0].file ?? null);
                sendFormData.append('CommercialLicenseFile', commercialLicenseFile[0].file ?? null);
                sendFormData.append('CompanyLogoFile', companyLogoFile[0].file ?? null);

                // sendFormData.append('GoogleRecaptchaResponse', recaptchaToken ?? null);
                if (companyProfileFile?.length > 0) {
                    sendFormData.append('CompanyProfileFile', companyProfileFile[0].file ?? null);
                }
                if (websiteBannerFile?.length > 0) {
                    sendFormData.append('WebsiteBannerFile', websiteBannerFile[0].file ?? null);
                }
                if (galleryImages?.length > 0) {
                    for (let index = 0; index < galleryImages.length; index++) {
                        const element = galleryImages[index];
                        sendFormData.append(`GalleryImages`, element.file ?? null);
                    }
                }
                const sendData = await sendOwnerServicesData(sendFormData);
                if (sendData.status == 200) {
                    if (sendData.data?.status?.responseCode == '200') {
                        toast.success(translate('web.dataSavedSuccessfully', 'Data Saved Successfully'))
                        resetForm();
                        setTimeout(() => {
                            navigate('/');
                        }, 3000);
                    } else {
                        toast.error(translate(sendData.data?.status?.detailedResponseCode, sendData.data?.status?.detailedResponseCode))
                    }
                }

                setLoading(false)
            } else {
                setLoading(false)
                return;
            }
        } catch (error) {
            setLoading(false)
        }
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            recaptchaRef.current.execute();
        }, 2000); // 1000 milliseconds = 1 second

        // Cleanup the timer if the component is unmounted
        return () => clearTimeout(timer);
    }, []);
    function resetForm() {
        setInputes(initInputes);
        setIdFile([]);
        setCommercialLicenseFile([]);
        setCompanyProfileFile([]);
        setCompanyLogoFile([]);
        setWebsiteBannerFile([]);
        setGalleryImages([]);
    }

    

    return (
        <>
            <ToastContainer
                position="top-right"
                closeOnClick
                theme="colored"
                autoClose={5000}
            />
            <div className={serviceRequestHeadContainer}>
                <h2 className={serviceRequestTitle + " d-flex align-items-center flex-wrap"}>
                    {translate('web.addYourCompanyDetails', 'Add Your Company Details')}
                </h2>
            </div>
            <EahsForm isSectionTitle className={'mb-main'} ish3 >
                <input type='hidden' value={recaptchaToken} name='GoogleRecaptchaResponse' />
                <div className={'col-12 mb-form-group'}>
                    <NetaqInput
                        type='select'
                        name='Type'
                        label={translate('web.selectType', 'Select Type')}
                        placeholder={translate('web.selectType', 'Select Type')}
                        listSelect={types}
                        required
                        onChange={(selectItem) => {
                            setInputes((prev) => ({
                                ...prev,
                                OwnerServiceId: selectItem.value,
                            }));
                        }}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='text'
                        name='OwnerNameEn'
                        label={translate('web.fullnameEn', 'Owner Name En')}
                        placeholder={translate('web.fullnameEn', 'Owner Name En')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='text'
                        name='OwnerNameAr'
                        label={translate('web.fullnameAr', 'Owner Name Ar')}
                        placeholder={translate('web.fullnameAr', 'Owner Name Ar')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='text'
                        name='ChargePersonNameEn'
                        label={translate('web.ChargePersonNameEn', 'Charge Person Name En')}
                        placeholder={translate('web.ChargePersonNameEn', 'Charge Person Name En')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='text'
                        name='ChargePersonNameAr'
                        label={translate('web.ChargePersonNameAr', 'Charge Person Name Ar')}
                        placeholder={translate('web.ChargePersonNameAr', 'Charge Person Name Ar')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='text'
                        name='CommercialNameEn'
                        label={translate('web.CommercialNameEn', 'Charge Person Name En')}
                        placeholder={translate('web.CommercialNameEn', 'Charge Person Name En')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='text'
                        name='CommercialNameAr'
                        label={translate('web.CommercialNameAr', 'Charge Person Name Ar')}
                        placeholder={translate('web.CommercialNameAr', 'Charge Person Name Ar')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={'phone'}
                        label={translate("web.phoneNo", "Phone No")}
                        name={'phone'}
                        placeholder={'971xxxxxxxxx'}
                        required={true}
                        onChange={(value) => { setPhoneNumber(value, 'Phone') }}
                        setIsPhoneNumberValid={setIsPhoneNumberValid} />
                    {!isPhoneNumberValid &&
                        <div className='text-danger'>
                            {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                        </div>}
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={'phone'}
                        label={translate("web.mobileNumber", "Mobile No")}
                        name={'phone'}
                        placeholder={'971xxxxxxxxx'}
                        required={true}
                        onChange={(value) => { setPhoneNumber(value, 'Mobile') }}
                        setIsPhoneNumberValid={setIsMobileNumberValid} />
                    {!isMobileNumberValid &&
                        <div className='text-danger'>
                            {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                        </div>}
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='text'
                        name='Website'
                        label={translate('web.Website', 'Website')}
                        placeholder={translate('web.Website', 'Website')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='email'
                        name='Email'
                        label={translate('web.Email', 'Email')}
                        placeholder={translate('web.Email', 'Email')}
                        required
                        onChange={handleChange}
                    />
                </div>
            </EahsForm>
            <EahsForm isSectionTitle title={translate('web.details', 'details')} className={'mb-main'} ish3 >
                <div className={eformInput}>
                    <NetaqInput
                        type='textarea'
                        name='About'
                        label={translate('web.aboutEn', 'aboutEn')}
                        placeholder={translate('web.aboutEn', 'aboutEn')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='textarea'
                        name='AboutAr'
                        label={translate('web.aboutAr', 'aboutAr')}
                        placeholder={translate('web.aboutAr', 'aboutAr')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='textarea'
                        name='Mission'
                        label={translate('web.MissionEn', 'Mission En')}
                        placeholder={translate('web.MissionEn', 'Mission En')}
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='textarea'
                        name='MissionAr'
                        label={translate('web.MissionAr', 'Mission Ar')}
                        placeholder={translate('web.MissionAr', 'Mission Ar')}
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='textarea'
                        name='Vission'
                        label={translate('web.VissionEn', 'VissionEn')}
                        placeholder={translate('web.VissionEn', 'VissionEn')}
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='textarea'
                        name='VissionAr'
                        label={translate('web.VissionAr', 'VissionAr')}
                        placeholder={translate('web.VissionAr', 'VissionAr')}
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='textarea'
                        name='Values'
                        label={translate('web.ValuesEn', 'Values En')}
                        placeholder={translate('web.ValuesEn', 'Values En')}
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='textarea'
                        name='ValuesAr'
                        label={translate('web.ValuesAr', 'Values Ar')}
                        placeholder={translate('web.ValuesAr', 'Values Ar')}
                        onChange={handleChange}
                    />
                </div>
            </EahsForm>
            <EahsForm isSectionTitle title={translate('web.attachments', 'Attachments')} className={'mb-main'} ish3 >
                <div className={eformInput}>
                    <label className="capatalize_text">
                        {translate('web.IdFile', 'Id File')} <span className="color-eahsred" >*</span>
                    </label>
                    <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={idFile} onChange={(e) => handleUpload(e, setIdFile)} key={'IdFile'} />
                </div>
                <div className={eformInput}>
                    <label className="capatalize_text">
                        {translate('web.CommercialLicenseFile', 'CommercialLicenseFile')} <span className="color-eahsred" >*</span>
                    </label>
                    <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={commercialLicenseFile} onChange={(e) => handleUpload(e, setCommercialLicenseFile)} key={'CommercialLicenseFile'} />
                </div>
                <div className={eformInput}>
                    <label className="capatalize_text">
                        {translate('web.CompanyProfileFile', 'CompanyProfileFile')}
                    </label>
                    <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={companyProfileFile} onChange={(e) => handleUpload(e, setCompanyProfileFile)} key={'CompanyProfileFile'} />
                </div>
                <div className={eformInput}>
                    <label className="capatalize_text">
                        {translate('web.CompanyLogoFile', 'CompanyLogoFile')} <span className="color-eahsred" >*</span>
                    </label>
                    <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={companyLogoFile} onChange={(e) => handleUpload(e, setCompanyLogoFile)} key={'CompanyLogoFile'} />
                </div>
                <div className={eformInput}>
                    <label className="capatalize_text">
                        {translate('web.WebsiteBannerFile', 'WebsiteBannerFile')} <span className="color-eahsred" >*</span>
                    </label>
                    <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={websiteBannerFile} onChange={(e) => handleUpload(e, setWebsiteBannerFile)} key={'WebsiteBannerFile'} />
                </div>
                <div className={eformInput}>
                    <label className="capatalize_text">
                        {translate('web.GalleryImages', 'Gallery Images')}
                    </label>
                    <SimpleUpload accept="image/*,application/pdf" isMulti={true} isServer={false} initialFiles={galleryImages} onChange={(e) => handleUpload(e, setGalleryImages)} key={'WebsiteBannerFile'} />
                </div>
            </EahsForm>
            <ReCAPTCHA
                sitekey={recaptchaSiteKey}
                size="invisible"
                ref={recaptchaRef}
                onChange={(token) => {
                    if (recaptchaValidate == false) {
                        setRecaptchaToken(token);
                        setRecaptchaVaidate(true);
                    }
                }}
            />
            <NetaqInput
                type='checkbox'
                name='termsAndConditions'
                label={translate('web.ownerServicesTermsAndConditions', 'Owner Services Terms And Conditions')}
                placeholder={translate('web.ownerServicesTermsAndConditions', 'Owner Services Terms And Conditions')}
                required
                checked={agreeTerms}
                onChange={(e) => setAgreeTermsAndConditions(e.target.checked)}
            />
            <div className={eFormButtonsContainer}>
                {/* submit btn */}
                {loading ?
                    <Loader /> :
                    <SubmitServiceBtn
                        onClick={submitForm}
                        disabled={!agreeTerms}
                    // disabled={!recaptchaValidate}
                    />
                }
            </div>
        </>
    )
}
